import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="case_studies" />;

export const Route = createFileRoute("/es/casos-clientes/$slug")({
  loader: ({ params }) => loadContentMeta("case_studies", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/casos-clientes/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

